import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/HighlightOff';

const styles = {
  leftIcon: {
    padding: '0px 5px',
    width: 32,
    height: 32,
    color: '#2196F3'
  },
  bold: {
    fontWeight: 700
  },
  button100: {
    width: '100%'
  }
};

const enhance = compose(pure);

const button = enhance(({ id, onClickAction, className, classes }) => {
  return (
    <Button
      className={[className, classes.button100]}
      color="primary"
      onClick={() => {
        onClickAction(id);
      }}
    >
      <DeleteIcon className={classes.leftIcon} />
      <span className={classes.bold}>解除</span>
    </Button>
  );
});

export default withStyles(styles)(button);
